export default {
    'cdnBaseUrl': 'https://cdn.elluciancloud.com/assets/EDS2/',
    'appVersion': '3.8.0'
};